import styled from 'styled-components';

export const AccordionWrapper = styled.div<any>`
  display: block;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const Title = styled.h4`
  color: #122946;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  font-feature-settings: 'liga' off;
  margin: 0;
`;

export const IconWrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  margin-left: 8px;

  & [data-qa='chevron-icon'] {
    transition-duration: 1s;
    transition-property: transform;
  }

  ${(props) =>
    props.isOpen &&
    `
    & [data-qa="chevron-icon"] {
      transform: rotate(-180deg);
      transition-duration: 1s;
      transition-property: transform;
    }
  `}
`;
